/* eslint-disable func-names, max-len, no-new, no-plusplus, no-shadow, no-underscore-dangle */
import 'jigowatt';
import 'jquery.fitvids';
import 'jquery.scrollto';
import 'nivo';
import 'onenav';
import 'owlcarousel-v1';
import 'fancybox-core';
import 'fancybox-media';
import WOW from 'wow.js';

// Initiat WOW.js
const wow = new WOW({ mobile: false });
wow.init();

// .intro-section reduce opacity when scrolling down
$(window).scroll(() => {
  if ($(window).width() > 1260) {
    const $introFirst = $('.intro:first');
    const $introSection = $('.intro-section');

    if ($introFirst.length && $introSection.length) {
      const windowScroll = $(window).scrollTop();
      const contentOpacity = 1 - windowScroll / ($introFirst.offset().top + $introFirst.height());
      $introSection.css('transform', `translateY(${Math.floor(windowScroll * 0.16)}px)`);
      $introSection.css('-webkit-transform', `translateY(${Math.floor(windowScroll * 0.16)}px)`);
      $introSection.css('opacity', contentOpacity.toFixed(2));
    }
  }
});

// Fixed navigation
$(window).scroll(() => {
  if ($(window).scrollTop() > 500) {
    $('.sub-navbar').addClass('fixednav');
  } else {
    $('.sub-navbar').removeClass('fixednav');
  }
});

$(window).scroll(() => {
  const scroll = $(window).scrollTop();
  const newsletter = $('.newsletter-footer');
  if (newsletter.length) {
    const newsletterPosition = newsletter.offset().top - 400;
    if (scroll < newsletterPosition) {
      $('.sticky-footer').css('display', 'block');
    } else {
      $('.sticky-footer').css('display', 'none');
    }
  }
});

// Forced to do this to remove a custom carousel from a wysiwyg from the page when on mobile..
$(document).ready(() => {
  if (matchMedia('(max-width: 768px)').matches) {
    const $toRemove = $('#myDiv-fluidwidth');
    const $startingDiv = $('#myDiv');

    if ($toRemove.length && $startingDiv.length) {
      $toRemove.remove();
      $startingDiv.attr('style', 'height: 0 !important');
    }
  }
});

// Dynamically generate the navigation based on the widgets placed on the page.
const $navItems = $('.promo-page .sub-nav');
const $pageSections = $('.promo-page .promo-page-section');
let isEmptyNav = true;
$pageSections.each((i, v) => {
  const activeItem = i === 0 ? 'class="current"' : '';

  if (
    $(v).data('navigation') !== undefined &&
    $(v)
      .data('navigation')
      .trim() !== ''
  ) {
    isEmptyNav = false;
    $navItems.append(
      `<li ${activeItem}><a href="#${$(v).attr('id')}">${$(v).data('navigation')}</a></li>`,
    );
  }
});

if (isEmptyNav) {
  $('.sub-navbar').hide();
}

// Initiat onepageNav.js
$('.sub-nav').onePageNav({ currentClass: 'current', scrollOffset: 500 });

// Hide Mobile Nav when clicking item
$('.sub-nav a, .sub-navbar-header a').click(() => {
  $('.sub-navbar-collapse')
    .removeClass('in')
    .addClass('collapse');
});

/* Buttons Scroll to Div */
$('.navbar-brand').click(() => {
  $.scrollTo($('.promo-page-section')[0], 1000);
  return false;
});

$('a.mouse').click(() => {
  $.scrollTo($('.promo-page-section')[1], 1000);
  return false;
});

$('.aStickyFooter').click(() => {
  $.scrollTo($('.newsletter-footer')[0], 1000);
});

const $btnIntroLeft = $('.js-btn-intro-left');
if ($btnIntroLeft.length) {
  const scrollToLeft = $btnIntroLeft.data('scrollto');

  $btnIntroLeft.click(() => {
    $.scrollTo($(`*[data-navigation="${scrollToLeft}"]`), 1000);
  });
}

const $btnIntroRight = $('.js-btn-intro-right');
if ($btnIntroRight.length) {
  const scrollToRight = $btnIntroRight.data('scrollto');

  $btnIntroRight.click(() => {
    $.scrollTo($(`*[data-navigation="${scrollToRight}"]`), 1000);
  });
}

// Screenshot carousel
$('.screens').owlCarousel({
  items: 4,
  navigation: true,
  navigationText: [
    "<i class='fa fa-caret-left btn-slide'></i>",
    "<i class='fa fa-caret-right btn-slide'></i>",
  ],
  pagination: false,
  itemsDesktop: [1000, 4],
  itemsDesktopSmall: [990, 3],
  itemsTablet: [600, 1],
  itemsMobile: false,
});

// Screenshot lightbox
$('.screens a').fancybox();

// Brief carousel
$('.small-slider').owlCarousel({
  items: 1,
  navigation: true,
  navigationText: [
    "<i class='fa fa-caret-left btn-slide'></i>",
    "<i class='fa fa-caret-right btn-slide'></i>",
  ],
  pagination: false,
  itemsDesktop: [1000, 1],
  itemsDesktopSmall: [900, 1],
  itemsTablet: [600, 1],
  itemsMobile: false,
});

// Testemonial carousel
$('.testemonials').owlCarousel({
  autoPlay: 8000,
  autoHeight: true,
  singleItem: true,
  navigation: false,
  itemsDesktop: [1000, 1],
  itemsDesktopSmall: [900, 1],
  itemsTablet: [600, 1],
  itemsMobile: false,
});

// Initiat fitVids.js
$('.video-item').fitVids();

// Bootstrap Tab navigation
$('.tabs a').click(function(e) {
  e.preventDefault();
  $(this).tab('show');
});

// Testemonial carousel
$('.customer-slider').owlCarousel({
  autoPlay: 8000,
  items: 5,
  pagination: false,
  itemsDesktop: [1000, 1],
  itemsDesktopSmall: [900, 1],
  itemsTablet: [600, 1],
  itemsMobile: false,
});

// var video = $(".intro-video").get(0);
// if (video) {
//    video.addEventListener('click', function () {
//        video.play();
//    }, false);
// }

const $onekey = $('.promo-page-section');
if ($onekey.length > 0) {
  /* Return the given number left-padded with zeroes to reach the required length */
  const padLeft = function(number, padTo) {
    number = number.toString();
    while (number.length < padTo) {
      number = `0${number}`;
    }

    return number;
  };

  $(document).ready(() => {
    const $countdownSection = $('.promo-page-section .landing__countdown');
    const $dateField = $countdownSection.find("input[id$='hdnEndDateTime']");

    if ($dateField.length > 0) {
      let isRunning = true;
      setInterval(() => {
        if (!isRunning) return;

        const endDateTime = new Date(parseInt($dateField.val(), 10));

        // Total time beteen the dates in seconds
        let remainder = Math.abs(endDateTime - new Date()) / 1000;

        // Remove the countdown section when the timer reaches zero
        if (remainder < 0) {
          $countdownSection.remove();
        }

        // Remaining time in days
        const days = Math.floor(remainder / 86400);
        remainder -= days * 86400;

        // Remaining time in hours
        const hours = Math.floor(remainder / 3600) % 24;
        remainder -= hours * 3600;

        // Remaining time in minutes
        const minutes = Math.floor(remainder / 60) % 60;
        remainder -= minutes * 60;

        // Remaining time in seconds
        const seconds = Math.floor(remainder % 60);

        $countdownSection.find('.days span').text(days);
        $countdownSection.find('.hours span').text(padLeft(hours, 2));
        $countdownSection.find('.minutes span').text(padLeft(minutes, 2));
        $countdownSection.find('.seconds span').text(padLeft(seconds, 2));

        if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
          isRunning = false;
        }
      }, 1000);
    }
  });
}
